import React from "react";
import { Input } from "reactstrap";

const FilterWithAccent = ({ filter, setFilter }) => {
  const normalizeText = (text) => {
    return text
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase();
  };

  return (
    <Input
      placeholder="Digite aqui..."
      value={filter}
      onChange={(e) => setFilter(normalizeText(e.target.value))}
    />
  );
};

export default FilterWithAccent;
